import { clearSnackbar, useAppDispatch, useAppSelector } from '@dap/common/data-access';
import { Alert, Snackbar as MuiSnack, SnackbarProps } from '@mui/material';

export type SnackType = 'success' | 'error' | 'info';

export type CloseReason = 'timeout' | 'clickaway' | 'closeButton';

function Snackbar({ onClose, autoHideDuration = 6000, action, ...snackProps }: SnackbarProps) {
  const { message, variant } = useAppSelector((state) => state.snackbar);
  const dispatch = useAppDispatch();

  return (
    <MuiSnack
      open={!!message}
      onClose={() => dispatch(clearSnackbar())}
      autoHideDuration={autoHideDuration}
      {...snackProps}
    >
      <Alert
        action={action}
        onClose={() => dispatch(clearSnackbar())}
        severity={variant}
        sx={{ border: ({ palette }) => `1px solid ${palette.divider}` }}
      >
        {message}
      </Alert>
    </MuiSnack>
  );
}

export default Snackbar;
